"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var AccountingDocumentLineItem_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingDocumentLineItem = exports.AccountingDocumentTargetEnum = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const column_numeric_transformer_1 = require("../../transformers/column-numeric-transformer");
const hashable_1 = require("../../util/hashable");
const contact_profile_enum_1 = require("../contact-profile-enum");
const invoicing_target_1 = require("../invoicing-target");
const accounting_document_1 = require("./accounting-document");
var AccountingDocumentTargetEnum;
(function (AccountingDocumentTargetEnum) {
    AccountingDocumentTargetEnum["PARTNER"] = "partner";
    AccountingDocumentTargetEnum["BRAND"] = "brand";
    AccountingDocumentTargetEnum["BRAND_1"] = "brand_1";
    AccountingDocumentTargetEnum["BRAND_2"] = "brand_2";
    AccountingDocumentTargetEnum["CUSTOMER"] = "customer";
    AccountingDocumentTargetEnum["CUSTOMER_2"] = "customer_2";
    AccountingDocumentTargetEnum["SUPPLIER"] = "supplier";
    AccountingDocumentTargetEnum["AFFILIATE"] = "affiliate";
})(AccountingDocumentTargetEnum = exports.AccountingDocumentTargetEnum || (exports.AccountingDocumentTargetEnum = {}));
let AccountingDocumentLineItem = AccountingDocumentLineItem_1 = class AccountingDocumentLineItem {
    asHashableContent() {
        var _a, _b, _c, _d;
        return {
            jobNumber: (_a = this.jobNumber) === null || _a === void 0 ? void 0 : _a.toString(),
            description: (_b = this.description) === null || _b === void 0 ? void 0 : _b.toString(),
            quantity: (0, hashable_1.numToString)(this.quantity),
            unitPrice: (0, hashable_1.numToString)(this.unitPrice),
            totalPrice: (0, hashable_1.numToString)(this.totalPrice),
            invoicingTarget: (_c = this.invoicingTarget) === null || _c === void 0 ? void 0 : _c.toString(),
            targetType: (_d = this.targetType) === null || _d === void 0 ? void 0 : _d.toString(),
        };
    }
    clone() {
        const cloned = new AccountingDocumentLineItem_1();
        for (const [k, v] of Object.entries(this)) {
            cloned[k] = v;
        }
        cloned.id = undefined;
        return cloned;
    }
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'smallint',
    }),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "position", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    (0, typeorm_1.Index)(),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "jobNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "externalOrderId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'date',
    }),
    __metadata("design:type", Date)
], AccountingDocumentLineItem.prototype, "deliveryDate", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'double precision',
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "quantity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "measure", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "unitPrice", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "totalPrice", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "materialCostsPrice", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "installationCostsPrice", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 3,
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "currencySymbol", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'float4',
        nullable: false,
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "vatRate", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingDocumentLineItem.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingDocumentLineItem.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)('bigint', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], AccountingDocumentLineItem.prototype, "sortIndex", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.GeneralInvoicingTargetEnum,
        name: 'invoicing_target',
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "invoicingTarget", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AccountingDocumentTargetEnum,
        nullable: false,
        default: AccountingDocumentTargetEnum.CUSTOMER,
    }),
    __metadata("design:type", String)
], AccountingDocumentLineItem.prototype, "targetType", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => accounting_document_1.AccountingDocument, (document) => document.lineItems),
    __metadata("design:type", accounting_document_1.AccountingDocument)
], AccountingDocumentLineItem.prototype, "document", void 0);
AccountingDocumentLineItem = AccountingDocumentLineItem_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'AccountingDocumentLineItem',
        nameFunction: (i) => `${i.position}/${i.jobNumber}`,
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('accounting_document_line_item', { schema: 'accounting' })
], AccountingDocumentLineItem);
exports.AccountingDocumentLineItem = AccountingDocumentLineItem;
//# sourceMappingURL=accounting-document-line-item.js.map